<template>
  <div id="app">
    <loader ref="routeLoader" class="app-route-loader" />
    <component :is="layout">
      <router-view v-if="renderComponent" />
      <SessionTimeOutNotification @force-rerender="forceRerender" />
    </component>
    <PerformanceStatusBar />
  </div>
  <!-- <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </div> -->
</template>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #d9d9d9;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #d9d9d9;
}
</style>

<script>
import SessionTimeOutNotification from '@/components/Session/index.vue';
import { mapGetters } from 'vuex';
import { resetRouteLoading, subscribeRouteLoader } from '@/utils/routeLoader';
import PerformanceStatusBar from "@/components/PerformanceStatusBar.vue";
import { EventLogger, appVersionCheck } from "@/utils/obs";
import config from "@/utils/config";

const eventLogger = new EventLogger();

const DEFAULT_PAGE_TITLE = config.brand.pageTitle;

export default {
  name: "App",
  components: { SessionTimeOutNotification, PerformanceStatusBar },
  data() {
    return {
      renderComponent: true,
      unsubscribeRouteLoader: null,
      heightFrom: '',
      heightTo: '',
      scrollOptions: {
        mode: "native",
        sizeStrategy: "percent",
        detectResize: true,
        locking: false,
        preventDefault: true,
        preventDefaultOnMove: true,
        mousedownStep: 10,
        scrollPanel: {
          scrollingX: false,
        },
        rail: {
          opacity: 0,
          size: "3px",
          gutterOfSide: 0,
          keepShow: false,
        },
        bar: {
          showDelay: 300,
          // opacity: 0,
          background: "#202A44",
          keepShow: true,
          size: "3px",
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      marketInfo: "user/marketInfo",
    }),
    layout() {
      return this.$route.meta.layout || "default-layout";
    },
  },
  created() {
    document.title = "";
    eventLogger.init();
    appVersionCheck();
  },
  beforeUnmount() {
    eventLogger.destroy();
    document.title = DEFAULT_PAGE_TITLE;
    this.unsubscribeRouteLoader?.();
    resetRouteLoading();
  },
  mounted() {
    this.setTitle();
    this.unsubscribeRouteLoader = subscribeRouteLoader((visible) => {
      if (visible) {
        this.$refs.routeLoader?.start();
      } else {
        this.$refs.routeLoader?.hide();
      }
    });
  },
  watch: {
    marketInfo: {
      handler() {
        this.setTitle();
      },
      deep: true,
    },
  },
  methods: {
    forceRerender(status) {
      if (!status) return;

      resetRouteLoading();
      // Remove component from the DOM
      this.renderComponent = false;
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    handleScroll() {
      // if (vertical.scrollTop > 0) {
      // document.getElementsByClassName('cs-header')[0].classList.add('cs-header_scrolled');
      // } else {
      //   document.getElementsByClassName('cs-header')[0].classList.remove('cs-header_scrolled');
      // }
    },
    setTitle() {
      const partnerLabel =
        this.marketInfo?.whiteLabel?.colorSchema?.partnerLabel;

      document.title = partnerLabel || DEFAULT_PAGE_TITLE;

      if (this.marketInfo?.whiteLabel?.colorSchema?.logo) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.getElementsByTagName("head")[0].appendChild(link);
        }
        link.href = this.marketInfo.whiteLabel.colorSchema.logo;
      }
    },
  },
};
</script>
